const content = {
  title: "Yhteystiedot",
  address: "Eläinkuja 12, 00100 Helsinki",
  phone: "Puh: 010 123 4567",
  email: "info@elainklinikka.fi",
  hoursTitle: "Aukioloajat",
};

export default content;
